import { theme } from '@/utils/theme';

export const classes = {
  wrapper: 'grid grid-cols-2 gap-4',
  toggleBlock: 'flex justify-between',
  option: 'py-1 px-0 w-[1.75rem] bg-grey-2 dark:bg-white/[0.06]',
  label: 'text-sm font-semibold text-grey-8 dark:text-mauve-1 mb-1 ml-1',
};

export const styles = {
  option: {
    '&.Mui-selected': {
      backgroundColor: theme.palette['red-2'].main,
      color: theme.palette['white'].main,
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.palette['red-3'].main,
      color: theme.palette['white'].main,
    },
    '&:not(.Mui-selected)': {
      // NOTE: Default MUI theme is also using `!important`, need to override with specificity
      border: `1px solid ${theme.palette['grey-4'].main} !important`,
      backgroundColor: theme.palette['white'].main,
      '.dark &': {
        border: '1px solid rgba(255,255,255,0.1) !important',
        backgroundColor: 'rgba(255,255,255,0.06)',
      },
    },
  },
};
